<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <h3>Organisationseinheiten</h3>
      <button @click="$router.push('/organisations/add')" type="button" class="btn btn-primary btn-sm d-flex align-items-center">
        <img class="mr-2" src="../../assets/icons/pencil.svg" /> Neue Organisationseinheit anlegen
      </button>
    </div>
    <List :columns="columns" :values="organisations"
          :clickable="true" @clicked="$router.push('/organisations/' + $event)"
          emptyText="Bisher keine Organisationen vorhanden">
      <template #column_admins="{data}">
        <div @click.prevent="$router.push('/organisations/' + data.id + '/admins')">{{ data.admins }}</div>
      </template>
      <template #column_action="{data}">
        <div v-if="data.active" class="actions">
          <img @click="$router.push('/organisations/' + data.id + '/admins')" src="../../assets/icons/users.svg" />
          <img @click="$router.push('/organisations/' + data.id)" src="../../assets/icons/settings.svg" />
        </div>
        <div v-else class="actions">
          <img @click="$router.push('/organisations/' + data.id + '/admins')" src="../../assets/icons/users_grey.svg" />
          <img @click="$router.push('/organisations/' + data.id)" src="../../assets/icons/settings_grey.svg" />
        </div>
      </template>
      <template #column_createdAt="{data}">{{ data.createdAt | dateFormat }}</template>
    </List>
  </div>
</template>

<script>
import {broadcast} from "@/util/eventHandler.js";
import List from "@/components/partial/List.vue";

export default {
  name: "OrganisationsList",
  components: {List},
  data() {
    return {
      columns: [
        { name: "Name", key: "name", styles: { "min-width": "140px" } },
        { name: "Beschreibung", key: "description" },
        { name: "Admins", key: "admins", styles: { "min-width": "175px" } },
        { name: "Aktion", key: "action", styles: { width: "100px" } },
        { name: "Erstellt", key: "createdAt", styles: { width: "100px" } }
      ]
    };
  },
  computed: {
    organisations() {
      return this.$store.state.organisations;
    }
  },
  created() {
    this.loadOrganisations();
    // this.loadAdmins();
  },
  methods: {
    async loadOrganisations() {
      console.log("Load organisations...");
      try {
        await this.$store.dispatch("FETCH_ORGANISATIONS");
      } catch (e) {
        broadcast("error", e);
      }
    },
    async loadAdmins() {
      console.log("Load admins...");
      try {
        await this.$store.dispatch("FETCH_ADMINS");
      } catch (e) {
        broadcast("error", e);
      }
    }
  }
};
</script>

<style lang="scss">
.actions {
  display: flex;
  gap: 10px;

  > img:hover {
    cursor: pointer;
  }
}
</style>
